// extracted by mini-css-extract-plugin
module.exports = {"phoneControl":"PhoneFlagInput_phoneControl__3HilU","input":"PhoneFlagInput_input__B2ycT","error":"PhoneFlagInput_error__zz5j2"};